// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ParagraphOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 448 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M192 32h224c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V96h-32v352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96h-32c-88.4 0-160-71.6-160-160S103.6 32 192 32z"}}]},"name":"paragraph","theme":"outlined"};

const ParagraphOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ParagraphOutlinedSvg} />;
  ParagraphOutlined.displayName = 'ParagraphOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ParagraphOutlined);
